var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M20.945 10.014l-8.63-2.86c-.205-.069-.426-.069-.63 0l-8.63 2.86L.68 13.785c-.295.467-.154 1.085.313 1.38.068.042.142.077.218.102l1.6.53v4.435c0 .431.276.814.686.95l8.187 2.713c.204.068.425.068.63 0l8.187-2.714c.409-.135.685-.518.685-.949v-4.435l1.6-.53c.524-.174.809-.74.635-1.264-.026-.076-.06-.15-.103-.218l-2.374-3.771zm-2.696.588L12 12.674 5.75 10.602 12 8.53l6.25 2.072zM2.147 14.095l1.67-2.652 7.11 2.356-1.67 2.653-7.11-2.357zm2.072 2.169l5.64 1.87 1.438-2.283v6.434l-7.078-2.346v-3.675zm8.484 6.02v-6.433l1.437 2.283 5.641-1.87v3.675l-7.078 2.346zm2.04-5.832l-1.67-2.653 7.11-2.356 1.67 2.652-7.11 2.357zM20.398 3.354c.275.274.275.72 0 .994l-1.99 1.99c-.274.275-.72.275-.994 0-.274-.274-.274-.72 0-.994l1.99-1.99c.275-.275.72-.275.994 0zm-15.198 0l1.99 1.99c.275.274.275.72 0 .994-.274.274-.72.274-.994 0l-1.99-1.99c-.275-.275-.275-.72 0-.994.274-.275.72-.275.994 0zm3.639-2.102l1.077 2.6c.149.36-.022.77-.38.92-.359.148-.77-.023-.919-.381L7.54 1.79c-.148-.36.022-.77.38-.92.36-.148.77.022.919.381zm7.846-.38c.358.148.529.56.38.918l-1.077 2.6c-.149.36-.56.53-.919.381-.358-.149-.529-.56-.38-.918l1.077-2.6c.149-.36.56-.53.919-.381zM12.302 0c.389 0 .703.315.703.703v2.815c0 .388-.314.702-.703.702-.388 0-.703-.314-.703-.702V.703c0-.388.315-.703.703-.703z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }